import { AnimatePresence } from 'framer-motion'
import { motion } from 'framer-motion'
import { ReactNode } from 'react'

import styles from './BottomSheet.module.scss'

type Props = {
  children: ReactNode
  isOpen: boolean
  onClose: () => void
  height?: number
  className?: string
}

export const BottomSheet = ({
  children,
  isOpen,
  onClose,
  height,
  className,
}: Props) => {
  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.backdrop}
          onClick={handleBackdropClick}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            className={
              className ? `${styles.popup} ${className}` : styles.popup
            }
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 300 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.grabber} onClick={onClose}></div>
            <div className={styles.content}>{children}</div>
            <div className={styles.homeIndicator} />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
